import * as tslib_1 from "tslib";
import { pick } from '@nextiva/analytics-common';
import { themr } from '@nextiva/analytics-lib';
import cx from 'classnames';
import { isEqual } from 'lodash';
import * as React from 'react';
import BarChart from './BarChart';
import Styles from "./Charts.css";
import FunnelChart from './FunnelChart';
import HeatMapChart from './HeatMapChart';
import LineChart from './LineChart';
import PieChart from './PieChart';
import ScatterChart from './ScatterChart';

var Chart =
/** @class */
function (_super) {
  tslib_1.__extends(Chart, _super);

  function Chart() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Chart.prototype.shouldComponentUpdate = function (nextProps) {
    return !isEqual(this.props, nextProps);
  };

  Chart.prototype.render = function () {
    var Component = 'div';
    var commonProps = pick(this.props, ['data', 'title', 'theme', 'height', 'className', 'timeRange', 'disableDownload', 'responsive', 'legendEnabled', 'onGraphItemClick']);
    var extraProps = {};
    var finalClassName = cx(commonProps.theme.chart, commonProps.disableDownload && commonProps.theme.isDownloadDisabled);

    switch (this.props.type) {
      case 'line':
        Component = LineChart;
        Object.assign(extraProps, pick(this.props, ['unit', 'legendPosition', 'enabledLegendItems', 'lineChartType', 'smooth', 'stacked']));
        break;

      case 'bar':
        Component = BarChart;
        Object.assign(extraProps, pick(this.props, ['unit', 'legendPosition', 'enabledLegendItems', 'stacked', 'rotated']));
        break;

      case 'stack':
        var props = tslib_1.__assign({}, this.props, {
          stacked: true
        });

        Component = BarChart;
        Object.assign(extraProps, pick(props, ['unit', 'legendPosition', 'enabledLegendItems', 'stacked', 'rotated']));
        break;

      case 'pie':
        Component = PieChart;
        Object.assign(extraProps, pick(this.props, ['unit', 'legendPosition', 'alignLegend', 'pieColor', 'pieLabelText', 'donut']));
        break;

      case 'scatter':
        Component = ScatterChart;
        Object.assign(extraProps, pick(this.props, ['unit', 'updateChartData', 'isDrillingDown', 'isSecondLevel', 'triggerCallRecordingModal']));
        break;

      case 'heat':
        Component = HeatMapChart;
        Object.assign(extraProps, pick(this.props, ['unit']));
        break;

      case 'funnel':
        Component = FunnelChart;
        Object.assign(extraProps, pick(this.props, ['unit']));
        break;
    }

    return React.createElement("div", {
      className: finalClassName
    }, React.createElement(Component, tslib_1.__assign({}, commonProps, extraProps)));
  }; // Refer to individual chart for PropTypes


  Chart.defaultProps = {
    responsive: false,
    legendEnabled: true
  };
  return Chart;
}(React.Component);

export default themr(Chart, Styles);